<template>
  <div v-if="page">
    <BaseHeading
      v-viewport-animated="{ mode: 'fade-translate' }"
      :content="page.description"
      :lead="page.lead"
      :image="page.image"
      :title="`<span data-tag='p'>${page.title}</span>`"
      :title-sup="page.country"
      wildwaffle-title
    >
      <template #right>
        <p v-if="page.nearest_event?.fixed_date">
          <span
            aria-hidden="true"
            v-html="
              `${formatDate(page.nearest_event.fixed_date, 'D.MM', false)}`
            "
          />
          <span
            class="visually-hidden"
            v-html="
              `${formatDate(page.nearest_event.fixed_date, 'Do MMMM', false)}`
            "
          />
        </p>
        <p
          v-else
          v-html="`${t('date')}: <span class='tba'>${t('tba')}</span>`"
        />

        <p
          v-html="
            page.nearest_event?.place?.name ||
            `${t('stage')}: <span class='tba'>${t('tba')}</span>`
          "
        />
      </template>
    </BaseHeading>
    <Widgets :widgets="page.widgets" virtual-first-widget />
  </div>
  <div v-else />
</template>

<script lang="ts" setup>
import { useBreadcrumbs } from '@/state/breadcrumbs'
import { useAnimationDisabled } from '@/state/pixelAnimationData'

const { t } = useI18n()
const route = useRoute()

const slug = flatten(route.params.slug)
const { data: page, error } = await useAsyncData(
  async () => await useApi().publicPagesArtistsRetrieve(slug)
)

if (error.value) {
  throw createError({ statusCode: 404, statusMessage: 'Page Not Found' })
}

const pixelAnimationDisabled = useAnimationDisabled()
pixelAnimationDisabled.value = Boolean(page.value?.pixels_disabled)

const { setBreadcrumbs } = useBreadcrumbs()

if (page.value)
  setBreadcrumbs([
    {
      text: page.value?.breadcrumb?.title,
      to: {
        name: 'slug',
        params: { slug: page.value?.breadcrumb?.slug }
      }
    },
    {
      text: page.value?.title,
      to: { name: 'artist-slug', params: { slug: page.value?.slug } }
    }
  ])

defineI18nRoute({
  paths: {
    en: '/artist/[slug]',
    pl: '/artysta/[slug]'
  }
})

const setI18nParams = useSetI18nParams()
setI18nParams({
  pl: { slug: page?.value?.slug_pl },
  en: { slug: page?.value?.slug_en }
})

const meta = usePrepareSEOMeta(page)

useHead({
  title: page.value?.site_title,
  meta
})
</script>
